module.exports = __webpack_public_path__ + "static/BT-mobile-1-3fa66958ed9fa915e810fe07c2f601f2.jpg";